import React, { FC } from 'react'
import images from '../../../../app/utlis/image'
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg'
import { getImage } from '../../../../app/utlis/imageConstants'
import { motion } from 'framer-motion'

interface EccProjectContentProps {
    ECCPageData: any
}

const EccProjectContent: FC<EccProjectContentProps> = ({ ECCPageData }) => {
    // Animation variants
    const cardVariants = {
        hidden: { opacity: 0, y: 40 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                delayChildren: 0.1
            }
        }
    };

    return (
        <div className='px-4 sm:px-8 md:px-12'>
            <motion.img
                src={images.ECCOVERVIEWIMAGE}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: false, amount: 0.3 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                className="w-full h-auto"
            />
            <motion.div
                className='grid grid-cols-1 md:grid-cols-2 justify-center items-center gap-4 md:gap-6 p-4 sm:p-8 md:p-20 pt-8 md:pt-16'
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
            >
                {ECCPageData.eccProjectDetails.websiteDetails.map((detail: any, index: number) => {
                    let img = getImage(detail?.image ?? "") ?? "";
                    return (
                        <motion.div
                            key={index}
                            variants={cardVariants}
                            custom={index}
                            initial={{
                                backgroundImage: 'none',
                                borderRadius: '1.5rem',
                            }}
                            whileHover={{
                                backgroundImage: `linear-gradient(145.33deg, #3560CA 0%, #1B1B1B 29.24%)`,
                                borderRadius: '1.5rem',
                                padding: '2px',
                                scale: 1.03,
                                transition: { duration: 0.3 }
                            }}
                            className='rounded-2xl sm:rounded-3xl'
                        >
                            <div className='bg-blackDark p-4 sm:p-6 rounded-2xl sm:rounded-3xl flex items-center gap-3 sm:gap-4 w-full'>
                                <motion.div
                                    className='w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center bg-darkGreyPrimary'
                                    whileHover={{ scale: 1.05 }}
                                    transition={{ duration: 0.2 }}
                                    viewport={{ once: false, amount: 0.2 }}
                                >
                                    <div className='flex items-center justify-center text-black font-black text-lg sm:text-xl'>
                                        <DynamicSVG color='#3560CA' >{img}</DynamicSVG>
                                    </div>
                                </motion.div>
                                <div className='flex flex-col gap-1'>
                                    <span className={`text-lg sm:text-xl font-medium text-white`}>
                                        <b>{detail.title}</b>
                                    </span>
                                    <span className='text-sm sm:text-base text-[#E0E0E0]'>
                                        {detail.sub_title}
                                    </span>
                                </div>
                            </div>
                        </motion.div>
                    )
                })}
            </motion.div>
        </div>
    )
}

export default EccProjectContent
